module.exports = __webpack_public_path__ + "static/media/ksh_logo.4be72f06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ksh_logo.svg
// module id = 1022
// module chunks = 0